import React, {useEffect, useState} from "react";
import { getAppointmentSummary, getPaymentSummary } from "../CallFilter";
import * as status from "../SelectList/Status";

function CumulativeData () {
    const [cumulativeData, setCumulativeData] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const paymentSummary = await getPaymentSummary();
            const appointmentSummary = await getAppointmentSummary();

            const appointmentStatDayExist = appointmentSummary.day !== undefined;
            const paymentStatDayExist = paymentSummary.day !== undefined;

            const appointmentStatWeekExist = appointmentSummary.week !== undefined;
            const paymentStatWeekExist = paymentSummary.week !== undefined;

            // const appointmentStatMonthExist = appointmentSummary.month !== undefined;
            // const paymentStatMonthExist = paymentSummary.month !== undefined;

            setCumulativeData([
                {
                    period: 'Journée',
                    patient: appointmentStatDayExist ? appointmentSummary.day[status.NEW_BY_PATIENT] : 0,
                    fingerprint: paymentStatDayExist ? paymentSummary.day['not_captured'] : 0,
                    practitioner: appointmentStatDayExist ? appointmentSummary.day[status.NEW_BY_PRACTITIONER] : 0,
                    closed: appointmentStatDayExist ? appointmentSummary.day[status.CLOSED] : 0,
                    paid: paymentStatDayExist ? paymentSummary.day['paid'] : 0,
                },
                {
                    period: 'Semaine',
                    patient: appointmentStatWeekExist ? appointmentSummary.week[status.NEW_BY_PATIENT] : 0,
                    fingerprint: paymentStatWeekExist ? paymentSummary.week['not_captured'] : 0,
                    practitioner: appointmentStatWeekExist ? appointmentSummary.week[status.NEW_BY_PRACTITIONER] : 0,
                    closed: appointmentStatWeekExist ? appointmentSummary.week[status.CLOSED] : 0,
                    paid: paymentStatWeekExist ? paymentSummary.week['paid'] : 0,
                },
                // {
                //     period: 'Mois',
                //     patient: appointmentStatMonthExist ? appointmentSummary.month[status.NEW_BY_PATIENT] : 0,
                //     fingerprint: paymentStatMonthExist ? paymentSummary.month['not_captured'] : 0,
                //     practitioner: appointmentStatMonthExist ? appointmentSummary.month[status.NEW_BY_PRACTITIONER] : 0,
                //     closed: appointmentStatMonthExist ? appointmentSummary.month[status.CLOSED] : 0,
                //     paid: paymentStatMonthExist ? paymentSummary.month['paid'] : 0,
                // }
            ]);
        }

        fetchData();
    }, []);

    return cumulativeData;
}

export default CumulativeData;


// WEBPACK FOOTER //
// ./src/views/Dashboardlive/Cumulative/CumulativeData.js